module.exports = __webpack_public_path__ + "static/img/badge-multi-scheduled.8f4d46c.svg";